/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CloudAccountIdFilters } from '../models/CloudAccountIdFilters';
import { CloudProviderFilters } from '../models/CloudProviderFilters';
import { IdFilters } from '../models/IdFilters';
import { ProjectIdFilters } from '../models/ProjectIdFilters';
import { ResourceTypeFilters } from '../models/ResourceTypeFilters';
import { SourceAccountProviderIdFilters } from '../models/SourceAccountProviderIdFilters';
import { TagKeyValuesFilters } from '../models/TagKeyValuesFilters';
import { TagKeysFilters } from '../models/TagKeysFilters';

export class CostDataFilters {
  'accountId'?: CloudAccountIdFilters;
  'sourceAccountProviderId'?: SourceAccountProviderIdFilters;
  'projectId'?: ProjectIdFilters;
  'cloudProvider'?: CloudProviderFilters;
  'resourceType'?: ResourceTypeFilters;
  'resourceId'?: IdFilters;
  'tagKeys'?: TagKeysFilters;
  'tagKeyValues'?: TagKeyValuesFilters;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "accountId",
      "baseName": "accountId",
      "type": "CloudAccountIdFilters",
      "format": ""
    },
    {
      "name": "sourceAccountProviderId",
      "baseName": "sourceAccountProviderId",
      "type": "SourceAccountProviderIdFilters",
      "format": ""
    },
    {
      "name": "projectId",
      "baseName": "projectId",
      "type": "ProjectIdFilters",
      "format": ""
    },
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "CloudProviderFilters",
      "format": ""
    },
    {
      "name": "resourceType",
      "baseName": "resourceType",
      "type": "ResourceTypeFilters",
      "format": ""
    },
    {
      "name": "resourceId",
      "baseName": "resourceId",
      "type": "IdFilters",
      "format": ""
    },
    {
      "name": "tagKeys",
      "baseName": "tagKeys",
      "type": "TagKeysFilters",
      "format": ""
    },
    {
      "name": "tagKeyValues",
      "baseName": "tagKeyValues",
      "type": "TagKeyValuesFilters",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CostDataFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

